export default "__VITE_ASSET__CJ5eYOoB__"